import React, { useMemo, useState } from 'react';

// Components
import Portal from '../Portal/Portal';
import FaultedCyclesModal from '../FaultedCyclesModal/FaultedCyclesModal';

// Types
import { FaultCheckableCycle, getFaultedCycleGroups } from '../../utils/getFaultedCycleGroup';

type ComponentProps = {
  cycles: FaultCheckableCycle[];
};

const FaultedCyclesButton: React.FC<ComponentProps> = ({ cycles }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const groups = useMemo(() => getFaultedCycleGroups(cycles), [cycles]);

  if (!groups.length) {
    return null;
  }

  const faultCount = groups.reduce((total, group) => total + group.faults.length, 0);

  return (
    <>
      <Portal>
        <button
          type="button"
          onClick={() => setIsModalOpen(true)}
          className="fixed left-0 top-0 z-9999 w-full bg-red px-4 py-2.5 text-center text-sm font-bold text-white shadow-md transition-opacity hover:opacity-90"
        >
          {`⚠ Faulted cycles (${groups.length} cycle${groups.length === 1 ? '' : 's'}, ${faultCount} channel${faultCount === 1 ? '' : 's'}) - click for details`}
        </button>
      </Portal>
      <FaultedCyclesModal groups={groups} isVisible={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default FaultedCyclesButton;
